import { render, staticRenderFns } from "./relatedAiFromWindow.vue?vue&type=template&id=74e0243a&"
import script from "./relatedAiFromWindow.vue?vue&type=script&lang=js&"
export * from "./relatedAiFromWindow.vue?vue&type=script&lang=js&"
import style0 from "./relatedAiFromWindow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74e0243a')) {
      api.createRecord('74e0243a', component.options)
    } else {
      api.reload('74e0243a', component.options)
    }
    module.hot.accept("./relatedAiFromWindow.vue?vue&type=template&id=74e0243a&", function () {
      api.rerender('74e0243a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/AirExport/components/AeBooking/relatedAiFromWindow.vue"
export default component.exports